export default {
	0: "Pending",
	1: "Enabled",
	2: "Used",
	3: "Canceled",
	4: "WaitingPayment"
};
